import { render, staticRenderFns } from "./AdminProductList.vue?vue&type=template&id=7326654e&scoped=true&"
import script from "./AdminProductList.vue?vue&type=script&lang=js&"
export * from "./AdminProductList.vue?vue&type=script&lang=js&"
import style0 from "./AdminProductList.vue?vue&type=style&index=0&id=7326654e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7326654e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7326654e')) {
      api.createRecord('7326654e', component.options)
    } else {
      api.reload('7326654e', component.options)
    }
    module.hot.accept("./AdminProductList.vue?vue&type=template&id=7326654e&scoped=true&", function () {
      api.rerender('7326654e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminProductList.vue"
export default component.exports